import React, {
  useCallback,
  useState,
  useContext,
  createContext,
  useMemo,
} from 'react';

const ModalSafraContext = createContext({});

export function ModalSafraProvider({ children }) {
  const [showModalSafra, setShowModalSafra] = useState(false);

  const openModalSafra = useCallback(() => {
    setShowModalSafra(true);
  }, []);

  const closeModalSafra = useCallback(() => {
    setShowModalSafra(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      showModalSafra,
      openModalSafra,
      closeModalSafra,
    }),
    [showModalSafra, openModalSafra, closeModalSafra],
  );

  return (
    <ModalSafraContext.Provider value={contextValue}>
      {children}
    </ModalSafraContext.Provider>
  );
}

export function useSafraModal() {
  const context = useContext(ModalSafraContext);

  if (!context)
    throw new Error('useSafraModal must be used within a ModalSafraProvider');

  return context;
}
